import apiFetch from '../../apiFetch'

export default function (dossierId, token, lastAccessDate, comment) {
  return apiFetch({ endPoint: `dossier/${dossierId}/CancelTransferRequest`, method: 'PUT', body: comment, token: token, lastAccessDate })
}
